import {connect} from 'react-redux';

import {globalNamespace} from '../../../helpers/models/namespaceHelpers';
import {makeMapDispatchToProps} from '../../../helpers/reselectHelpers';
import {CardModel, CardTypesEnum} from '../../../models/api/cardModel';
import {ContactModel} from '../../../models/api/contactModel';
import {ThunkAsyncAction} from '../../../store/appThunk';
import {updateCardAttributeAsyncAction} from '../../../store/data/cards/cardsActions';
import {createCardAndUpdateContactDetailsPanelAction} from '../../../store/panels/contacts/contactDetailsPanelActions';
import {ContactDetailsPanelId} from '../../../store/panels/panelStateBase';
import {ContactHeaderName} from './contactHeaderName';

/*
 * Props.
 */

interface ContactHeaderNameContainerProps {
  panelId: ContactDetailsPanelId;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<ContactHeaderNameContainerProps>()(({panelId}) => ({
  updateCardAttributeAsync: updateCardAttributeAsyncAction,
  onCreateNewCardAsync:
    (name: string, contact?: ContactModel): ThunkAsyncAction<CardModel | undefined> =>
    async (dispatch) => {
      // If we do not have a contact, we are not able to create a new card.
      if (!contact) {
        return undefined;
      }
      const newCard = await dispatch(
        createCardAndUpdateContactDetailsPanelAction(
          panelId,
          {
            // Can set to global, since this is an auto card.
            namespace: globalNamespace,
            name,
            contacts: [contact],
            type: CardTypesEnum.AUTO,
          },
          true,
        ),
      );
      return newCard;
    },
}));

export const ContactHeaderNameContainer = connect(null, mapDispatchToProps)(ContactHeaderName);
